type TrProps = {
  isFirstRow?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}


export default function Tr ({isFirstRow = false, disabled=false, children}: TrProps) {
  return (
    <tr className={`${disabled ? 'bg-[#F2F4F5] text-[#A2B0BF]' : 'hover:bg-indigo-50'} border-izygray border-collapse ${isFirstRow ? "" : 'border-t'}`}>
      {children}
    </tr>
  )
}